export const YandexKitStatus = {
    NOT_INITIALIZED: 'NOT_INITIALIZED',
    READY: 'READY',
    ERROR: 'ERROR',
} as const;
